module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-32f8c3055b2f748a104fdc9d0c8054ca.png";